import {
  Fragment,
  useEffect,
  useState,
  useRef,
  useContext,
  createRef,
} from "react";

import { get, post, put } from "../../../adapters/xhr/api";
import styleData from "../../../pages/UnifiedTaxDeclaration/settlementPaymenAccountDebtTaxpayerBehalf/SettlementTaxpayerDebt.module.css";
import stylesRequestData from "../UnifiedTaxDeclarationRequestData/index.module.css";
import stylesModal from "../../UnifiedTaxDeclaration/forms/formTypes/Modal.module.css";

import InputElement from "../../../shared/form/InputElement";
import {
  validateRequired,
  validateEgyptianPhoneNumber,
  validateEmail,
  validateNationalIDWithoutAgeLimit,
} from "../../../helpers/Validation";
import { previewAndDownloadDeclerationFile } from "../../../adapters/apis/lookups/lookups";
import MainContent from "../../../layouts/maincontent/MainContent";
import UnifiedTaxDeclarationContext from "../../../contexts/UnifiedTaxDeclarationProvider";
import { validateBeforeSubmit } from "../../../components/UnifiedTaxDeclaration/helpers/validationHelper";
import LoadingSpinner from "../../../components/Loading/LoadingSpinner";

import DownloadFile from "../../../helpers/DownloadFile";
import downloadIcon from "../../../assets/img/Icon feather-upload-cloud.png";
import InfoPopover from "../../../shared/form/InfoPopover";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { PaginationTax } from "../../../shared/pagination/Pagination";
import Modal from "react-modal";

const BulkUploadDocuments = ({ styleAddNewTaxDeclaration, setValidFields }) => {
  Modal.setAppElement("body");

  const unifiedTaxDeclarationContext = useContext(UnifiedTaxDeclarationContext);
  const {
    setDeclarationRequest,
    declarationRequest,
    setBackendError,
    isBulkUpload,
    setIsBulkUpload,
    bulkdUploadError,
    setBulkdUploadError,
  } = unifiedTaxDeclarationContext;
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const bulkUploadFileRef = useRef();
  const [showModal, setShowModal] = useState(false);
  const [fileUploadErrorMessage, setFileUploadErrorMessage] = useState("");
  const [singleUploadedFile, setSingleUploadedFile] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadedFilesLength, setUploadedFilesLength] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isUploadingFile, setIsUploadingFile] = useState(false);
  const [limit, setLimit] = useState(100);
  const [links, setLinks] = useState(null);

  const getUploadedFiles = async (
    index,
    newLimit,
    customId,
    silent = false,
  ) => {
    try {
      const targetId = id || declarationRequest?.id || customId;
      if (!silent) setIsLoading(true);
      if (targetId) {
        const response = await get(
          `api/declaration-system/units-bulk-upload/${targetId}/files?per_page=${newLimit || limit}&page=${index || 1}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          },
        );
        setLinks(response?.data?.links);
        setUploadedFiles(response?.data?.data);
        setCurrentPage(response?.data?.meta?.current_page);
        setUploadedFilesLength(response?.data?.meta?.total);
      }

      if (!silent) setIsLoading(false);
    } catch (error) {
      if (!silent) setIsLoading(false);
    }
  };

  useEffect(() => {
    getUploadedFiles(1, limit);
  }, []);

  const hasProcessingFile = uploadedFiles?.some(
    (file) => file?.status?.is_processing,
  );

  useEffect(() => {
    if (!hasProcessingFile) return;

    if (parseInt(uploadedFiles[0]?.status?.id) !== 1) {
      const intervalId = setInterval(() => {
        getUploadedFiles(currentPage, limit, null, true);
      }, 30000);

      return () => clearInterval(intervalId);
    }
  }, [currentPage, limit, hasProcessingFile, uploadedFiles]);

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    getUploadedFiles(1, newLimit);
  };

  const handlePreviewFile = async (url) => {
    try {
      const response = await previewAndDownloadDeclerationFile(url);

      const blob = new Blob([response?.data], {
        type: response.headers["content-type"],
      });

      // Create a URL for the blob
      const fileUrl = URL.createObjectURL(blob);
      window.open(fileUrl, "_blank");
    } catch (error) {
      if (error?.response?.status == 429) {
        alert("تعديت عدد المحاولات المسموح بها . يرجى الانتظار");
      }
    }
  };

  const handleDownloadFile = async (url) => {
    try {
      const response = await previewAndDownloadDeclerationFile(url);

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      // Extract filename from Content-Disposition header
      let fileName = "file"; // Default filename
      let originFileName = "file";
      const disposition = response.headers["content-disposition"];
      if (disposition) {
        const match = disposition.match(/filename="(.+?)"/);
        if (match) {
          originFileName = match[1];
        } else {
          const filenameMatch = disposition.match(/filename=([^;]+)/);
          if (filenameMatch) {
            originFileName = filenameMatch[1].trim();
          }
        }
      }

      const mimeType = blob.type;
      const ext = originFileName.split(".").pop().toLowerCase();

      if (ext === "jfif" || mimeType === "image/jfif") {
        fileName = "file.jfif";
      } else if (mimeType === "image/jpeg" || mimeType === "image/jpg") {
        fileName = ext === "jpg" ? "file.jpg" : "file.jpeg";
      }

      // Create a download link
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = originFileName.replace(/"/g, ""); // Remove any quotes
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      if (error?.response?.status == 429) {
        alert("تعديت عدد المحاولات المسموح بها . يرجى الانتظار");
      }
    }
  };

  const handleDownloadTemplate = async () => {
    try {
      handleDownloadFile("api/declaration-system/units-bulk-upload/template");
    } catch (error) {
      console.log("failed to download template");
    }
  };

  const handleUploadBulkFile = async (pc, c, key, value, i, bi, fi, ref) => {
    try {
      setBulkdUploadError(null);
      setIsUploadingFile(true);

      const data = new FormData();
      data.append("units_bulk_upload", value);

      if (value) {
        const response = await post(
          "api/declaration-system/units-bulk-upload/stage",
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          },
          data,
        );

        setSingleUploadedFile(response?.data?.data?.file_id);
        setShowModal(true);
        setIsUploadingFile(false);
      }
    } catch (error) {
      setIsUploadingFile(false);

      setSingleUploadedFile(null);
      setBulkdUploadError(
        error.response?.data?.message ||
          error.response?.data?.data?.message ||
          "خطأ في إرسال البيانات",
      );
    }
  };

  const sanitizeDeclarationRequest = () => {
    delete declarationRequest.fixed_installation;
    delete declarationRequest.hotel_facility;
    delete declarationRequest.industrial_facility;
    delete declarationRequest.mine_quarry;
    delete declarationRequest.petroleum_facility;
    delete declarationRequest.production_facility;
    delete declarationRequest.residential_units;
    delete declarationRequest.service_facilities;
    delete declarationRequest.service_units;
    delete declarationRequest.units_count;
    delete declarationRequest.vacant_land;
    delete declarationRequest.unit;

    declarationRequest.taxpayer.nationality_id = null;
    if (declarationRequest.taxpayer.phone == "20") {
      declarationRequest.taxpayer.phone = null;
    }
  };

  const submitDeclarationWithBulkFile = async () => {
    setIsLoading(true);
    let declarationId;
    setBulkdUploadError(null);
    sanitizeDeclarationRequest();
    try {
      if (singleUploadedFile) {
        declarationRequest.units_bulk_upload = {
          file_id: singleUploadedFile,
        };
        if (declarationRequest?.id) {
          const response = await put(
            `api/declaration-system/declarations/${declarationRequest?.id}`,
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
            },
            declarationRequest,
          );
        } else {
          const response = await post(
            `api/declaration-system/declarations`,
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
            },
            declarationRequest,
          );
          setDeclarationRequest((prev) => ({
            ...prev,
            ...response?.data?.data,
          }));
          declarationId = response?.data?.data?.id;
        }
        getUploadedFiles(1, limit, declarationId);
        setShowModal(false);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);

      setShowModal(false);
      setBulkdUploadError(
        error.response?.data?.message ||
          error.response?.data?.data?.message ||
          "خطأ في إرسال البيانات",
      );
    }
  };

  return (
    <>
      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={stylesModal.overlay}
        className={stylesModal.content}
      >
        <div className="col-lg-8 text-center">
          <h5>
            قد تستغرق عملية رفع الملف بضع دقائق، يرجى التأكد من اختيار الملف
            الصحيح قبل المتابعة. هل تريد الاستمرار؟
          </h5>
          <div className="d-flex gap-4 justify-content-center">
            <button
              className="btn btn-primary px-3"
              onClick={submitDeclarationWithBulkFile}
              disabled={isLoading}
            >
              نعم
            </button>
            <button
              className="btn btn-danger px-3"
              onClick={() => setShowModal(false)}
            >
              لا
            </button>
          </div>
        </div>
      </Modal>
      <MainContent>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <section className="pb-3 container">
            <div
              className={`${styleAddNewTaxDeclaration.container} container`}
              style={{ marginTop: "-70px" }}
            >
              <div className="flex-col d-md-flex  justify-content-between align-items-center flex-row mb-4">
                <div className="d-flex align-items-center mb-4">
                  <button
                    className={`${styleAddNewTaxDeclaration["btn-arrow"]} ms-3 mt-lg-1`}
                    onClick={() => {
                      setIsBulkUpload(false);
                      setBulkdUploadError(null);
                      if (
                        location?.pathname?.includes("/tax-declaration/add") &&
                        declarationRequest?.id
                      ) {
                        navigate(
                          `/tax-declaration/update/${declarationRequest?.id}`,
                        );
                      }
                    }}
                    disabled={hasProcessingFile || isLoading}
                  >
                    <i className="fa-solid fa-arrow-right mt-0"></i>
                  </button>

                  <h3 className="fw-bold m-0 mb-3 mt-2 mt-lg-0 mb-md-0">
                    العوده إلي&nbsp;
                    {declarationRequest?.viewMode
                      ? "تفاصيل الأقرار"
                      : declarationRequest?.editMode
                        ? "تعديل بيانات الإقرار"
                        : "تقديم إقرار"}
                  </h3>
                </div>
              </div>

              <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mb-3 w-100">
                <button
                  onClick={handleDownloadTemplate}
                  className={`${stylesRequestData["btn-download"]}`}
                >
                  <span>
                    تحميل نموذج الرفع المجمع للوحدات السكنية و الغير سكنية
                  </span>
                  <i className="fa-solid fa-download"></i>
                </button>

                <div className="col-md-12 col-sm-12 col-lg-4 mt-4 mt-sm-0">
                  <InputElement
                    fileInputRef={bulkUploadFileRef}
                    mb4="mb-4"
                    dimDisabled={
                      declarationRequest?.viewMode ||
                      hasProcessingFile ||
                      isLoading ||
                      isUploadingFile
                    }
                    inputIcon={`${stylesRequestData["input-icon"]} input-icon`}
                    labelHtmlFor="file"
                    labelClassName={`required ${stylesRequestData["form-label"]} form-label`}
                    labelText="رفع ملف الوحدات المجمعة"
                    inputType="file"
                    inputClassName={` ${stylesRequestData["form-control"]} form-control ${stylesRequestData["fileCustom"]}`}
                    inputID="file_input"
                    name="file"
                    fileName={
                      declarationRequest?.taxpayer?.file?.original_file_name ||
                      "إرفاق ملف"
                    }
                    pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                    icon="fa-solid fa-cloud-arrow-up"
                    accept="image/png, image/jpeg,image/jpg,application/pdf,image/JFIF"
                    pText={fileUploadErrorMessage}
                    onChange={handleUploadBulkFile}
                    disabled={
                      declarationRequest?.viewMode ||
                      hasProcessingFile ||
                      isLoading ||
                      isUploadingFile
                    }
                  />
                </div>
              </div>
            </div>
            <div className="mb-4">
              <h4 className={`${stylesRequestData["box-title"]} box-title`}>
                بيانات الملفات المرفوعة مسبقا{" "}
              </h4>
              <div
                className={`${stylesRequestData["table-responsive"]} table-responsive`}
              >
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col" className="h5 fw-bold">
                        اسم الملف
                      </th>
                      <th scope="col" className="h5 fw-bold">
                        تاريخ رفع الملف
                      </th>
                      <th scope="col" className="h5 fw-bold">
                        اسم المستخدم
                      </th>
                      <th scope="col" className="h5 fw-bold">
                        عدد الوحدات المضافة
                      </th>
                      <th scope="col" className="h5 fw-bold">
                        حالة الملف
                      </th>
                      <th scope="col" className="h5 fw-bold">
                        ملف الأخطاء
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {uploadedFiles?.length > 0 ? (
                      uploadedFiles?.map((file, index) => (
                        <tr key={index}>
                          <td>{file?.file_name}</td>
                          <td>{file?.upload_date}</td>
                          <td>{file?.uploaded_by}</td>
                          <td>{file?.units_added}</td>
                          <td>{file?.status?.name}</td>
                          <td className="align-items-end">
                            {file?.error_file ? (
                              <button
                                className="btn btn-outline-primary btn-sm d-flex align-items-center"
                                onClick={() =>
                                  handleDownloadFile(
                                    file?.error_file?.download_url,
                                  )
                                }
                              >
                                <i className="fa-solid fa-download ms-2"></i>
                                تحميل
                              </button>
                            ) : (
                              "-"
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="h5 text-center text-muted">
                          لا توجد ملفات متاحة
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {uploadedFilesLength > 0 && (
                <div className="mb-5">
                  <PaginationTax
                    limit={limit}
                    count={uploadedFilesLength}
                    active={currentPage}
                    callback={getUploadedFiles}
                    handleLimitChange={handleLimitChange}
                    isClaimPagination={true}
                    links={links}
                  />
                </div>
              )}
            </div>
          </section>
        )}
      </MainContent>
    </>
  );
};

export default BulkUploadDocuments;
